import { Component, inject } from '@angular/core';
import { EmptyStateComponent } from '@uigy/shared/components/empty-state/empty-state.component';
import { LanguageService } from '@uigy/shared/services/language.service';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
  selector: 'app-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
  imports: [
    EmptyStateComponent,
  ],
})
export class LoadingPageComponent {
  private languageService = inject(LanguageService);

  public readonly texts = this.languageService.texts;

  protected readonly IconsEnum = IconsEnum;
}
